import { InputAdornment, IconButton } from '@material-ui/core';
import { Search, FileCopy, ExpandMore } from '@material-ui/icons';
import { generateCode } from '@webapps/business';
import {
  Button,
  FormikAutocompletePx,
  FormikTextFieldPx,
  useMutation,
  useToast,
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect, useState } from 'react';

import Modal from 'components/Modal';
import { useLocation, useHistory } from 'react-router-dom';

const FiltersOrganismes = ({ formik = {}, schools = {}, refetch, type }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [openGenerateCode, setOpenGenerateCode] = useState(false);
  const [generatedCode, setGeneratedCode] = useState(null);
  const { addToast } = useToast();
  const { idUser } = useAuth();
  const { state } = useLocation();
  const { replace, location } = useHistory();

  useEffect(() => {
    if (state?.generateCode) {
      handleGenerateCode();
      replace({ ...location, state: {} });
    }
  }, [state]);

  const { mutateAsync: mutateGenerateCode } = useMutation(generateCode);
  
  const handleGenerateCode = async () => {
    try {
      const response = await mutateGenerateCode({
        id: idUser,
        data: {
          type: 'cfa',
        },
      });
  
      setGeneratedCode(response.data.code);
      setOpenGenerateCode(true);
      refetch();
    } catch (error) {
      addToast({
        status: 'error',
        message: 'Erreur lors de la génération du code',
      });
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedCode);
    addToast({
      status: 'success',
      message: 'Code copié dans le presse-papier',
    });
  };

  return (
    <div className={classes.container}>
      <div className={global.filtersContainerHeader}>
        <div>
          <FormikAutocompletePx
            formik={formik}
            getOptionLabel={(option) => option.name || ''}
            label="Organisme de formation"
            name="school"
            options={schools}
            value={schools.find((school) => school?.id === formik?.values?.school?.id) || null}
            className={global.formikAutocomplete}
            endAdornment={(
                <ExpandMore style={{ color: '#5D75A8' }} />
            )}
          />
        </div>
        {type === 'trainings' && (
          <>
            <div className={global.formikTextField}>
              <FormikTextFieldPx
                formik={formik}
                variant="outlined"
                name="trainingLabel"
                label="Intitulé de formation"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search style={{ color: '#92ABD2' }} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className={global.formikTextField}>
              <FormikTextFieldPx
                formik={formik}
                variant="outlined"
                name="rncp"
                label="N° RNCP"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search style={{ color: '#92ABD2' }} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className={global.formikTextField}>
              <FormikTextFieldPx
                formik={formik}
                variant="outlined"
                name="diplomaCode"
                label="Code diplôme"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search style={{ color: '#92ABD2' }} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className={classes.aggregatedButton}>
              <Button
                onClick={handleGenerateCode}
                variant="contained"
                color="primary"
              >
                Inviter un organisme de formation
              </Button>
            </div>
          </>
        )}
      </div>
      <div className={type === "trainings" && classes.disaggregatedButton}>
        <Button
          onClick={handleGenerateCode}
          variant="contained"
          color="primary"
        >
          Inviter un organisme de formation
        </Button>
      </div>
      <Modal
        onCancel={() => setOpenGenerateCode(false)}
        open={openGenerateCode}
        title="Votre nouveau code d’invitation :"
        withStep={false}
      >
      <div className={classes.copyToClipboardContainer}>
        <div className={classes.subTitle}>Appuyez sur le bouton pour copier le code</div>
        <div className={classes.subTitle}>(Votre code expire dans 6 mois)</div>
        <IconButton className={classes.copyToClipboard} onClick={copyToClipboard} color="primary">
          <FileCopy className={classes.copyToClipboardIcon} /> {generatedCode}
        </IconButton>
      </div>
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: spacing(2),
    '@media (max-width: 768px)': {
      flexDirection: 'column',
    },
    marginBottom: '20px',
  },
  disaggregatedButton: {
    display: 'flex',
    '@media (max-width: 1064px)': {
      display: 'none'
    },
  },
  aggregatedButton: {
    display: 'none',
    '@media (max-width: 1064px)': {
      display: 'flex'
    },
  }
});

export default FiltersOrganismes;
